export class UpdateLabReportModel {
    "dayNumber": Number;
    "studyId": Number;
    "mobileNumber": Number;
    "userId": Number;
    "patientId": Number;
    "testName": String;
    "testValue": String;
    "fileURL": String;
}